module.exports = __webpack_public_path__ + "img/Antonia&Stephan-03.f3cdfb82.jpg";